var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLightningGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Lightning"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.707 9.80151L7.95703 19.1765C7.86431 19.2755 7.74191 19.3416 7.60832 19.3649C7.47472 19.3882 7.33717 19.3674 7.21643 19.3056C7.09569 19.2439 6.9983 19.1446 6.93897 19.0226C6.87963 18.9007 6.86157 18.7627 6.8875 18.6296L8.03282 12.9007L3.53047 11.2101C3.43378 11.1739 3.34755 11.1144 3.27949 11.0367C3.21143 10.9591 3.16366 10.8658 3.14045 10.7653C3.11723 10.6647 3.1193 10.5599 3.14646 10.4603C3.17362 10.3607 3.22503 10.2694 3.2961 10.1945L12.0461 0.819477C12.1388 0.72052 12.2612 0.654407 12.3948 0.631115C12.5284 0.607823 12.666 0.628614 12.7867 0.690353C12.9074 0.752091 13.0048 0.851427 13.0642 0.973369C13.1235 1.09531 13.1416 1.23324 13.1156 1.36635L11.9672 7.10151L16.4695 8.78979C16.5655 8.8262 16.6511 8.8857 16.7186 8.96301C16.7861 9.04033 16.8336 9.13309 16.8567 9.2331C16.8799 9.33311 16.8781 9.43728 16.8514 9.53642C16.8248 9.63556 16.7741 9.7266 16.7039 9.80151H16.707Z",
    fill: "#65636A"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightningGrey);
export default __webpack_public_path__ + "static/media/Lightning-grey.f4446bd56e0050349d1f8da72d1d0e30.svg";
export { ForwardRef as ReactComponent };